import React from 'react';
import { Heart, Star, ShoppingCart } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { resolveImageUrl } from '../config';
import './ProductCard.css';

const ProductCard = ({ product }) => {
  const { wishlist, handleToggleWishlist, handleAddToCart } = useCart();
  const isWishlisted = wishlist.some((item) => item.id === product.id);

  const handleWishlistClick = (e) => {
    e.preventDefault();
    handleToggleWishlist(product);
  };

  const handleAddToCartClick = (e) => {
    e.preventDefault();
    handleAddToCart(product);
  };

  // Render stars based on rating
  const renderStars = (rating) => {
    const stars = [];
    const floorRating = Math.floor(rating);
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <Star
          key={i}
          size={14}
          fill={i <= floorRating ? '#FDBA12' : 'none'}
          color={i <= floorRating ? '#FDBA12' : '#dcdde1'}
        />
      );
    }
    return stars;
  };

  return (
    <div className="product-card">
      {/* Wishlist Icon Overlay */}
      <button 
        className={`wishlist-btn-overlay ${isWishlisted ? 'active' : ''}`}
        onClick={handleWishlistClick}
        aria-label={isWishlisted ? "Remove from wishlist" : "Add to wishlist"}
      >
        <Heart size={18} fill={isWishlisted ? '#ff4757' : 'none'} />
      </button>

      {/* Image Area */}
      <div className="product-card-img-wrapper">
        <img src={resolveImageUrl(product.image)} alt={product.title} loading="lazy" />
        {product.badge && (
          <span className="product-card-badge">{product.badge}</span>
        )}
      </div>

      {/* Info Area */}
      <div className="product-card-info">
        <h3 className="product-card-title">{product.title}</h3>
        
        {/* Rating Row */}
        <div className="product-card-rating-row">
          <div className="stars-list" aria-label={`Rating: ${product.rating} stars`}>
            {renderStars(product.rating)}
          </div>
          <span className="review-count-text">({product.reviewsCount} reviews)</span>
        </div>

        {/* Pricing Row */}
        <div className="product-card-price-row">
          <span className="current-price">₹{product.price}</span>
          <span className="old-price">₹{product.oldPrice}</span>
        </div>

        {/* Add to Cart Button */}
        <button className="add-to-cart-btn" onClick={handleAddToCartClick}>
          <ShoppingCart size={15} />
          <span>Add To Cart</span>
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
